import React, { memo, useEffect, useState } from 'react';
import '../../css/Send_E_Card.css';
import Button from '../../components/common/ui/Button';
import TranslateFile from '../../Loc/TranslateFile';
import { useDispatch, useSelector } from 'react-redux';
import SelectInput from '../../components/common/ui/Inputs/SelectInput';
import CustomInput from '../../components/common/CustomInput';
import { inboxActions } from '../../_store/inbox.slice';
import CustomKeyboard from '../../components/common/CustomKeyboard';
import Send_ECardsSchema from '../../validation/Send_ECardsSchema';
import CheckBoxInput from '../../components/common/ui/Inputs/CheckBoxInput';
import CustomPhoto from '../../components/common/CustomPhoto';
import CustomModal from '../../components/common/CustomModal ';
import PaymentModal from '../Message/PaymentModal';
import { E_CardActions } from '../../_store';
import Loader from '../../components/common/Loader';
import useCheckQuarantineWords from '../../hooks/useCheckQuarantineWords';
import { getStoredValue } from "../../_helpers/storageHelper";
import CustomEcard from '../../components/common/CustomEcard';


const Send_E_Card = ({ formData, setFormData, isshowListPage, setisshowListPage, rotation, setRotation, setLoading }) => {
    const [selectedCategories, setSelectedCategories] = useState([]);
    const [selectedCard, setSelectedCard] = useState(null);
    const currentLang = TranslateFile();
    const { MyContactsDisplayForEcardDetails } = useSelector(state => state.E_Card);
    const { ECardloadMoreCount } = useSelector(state => state.auth);
    const [errorMessage, setErrorMessage] = useState({});
    const dispatch = useDispatch();
    const { loginResponse, loginDetails } = useSelector(state => state.kioskLogin);
    const storedloginResponse = loginResponse || getStoredValue("loginResponse");
    const storedLoginDetails = getStoredValue("loginDetails") || loginDetails;
    const [IsKeyboardOpen, setIsKeyboardOpen] = useState(false);
    const { CactasServiceDetailsResult } = useSelector((state) => state.inbox);
    const [showPopup, setShowPopup] = useState(false);
    const [modalContent, setModalContent] = useState();
    const [modalContentColor, setmodalContentColor] = useState();
    const [currentField, setCurrentField] = useState('');
    const [values, setvalues] = useState();
    const allFields = ['subject'];
    const placeholder = { subject: currentLang?.placeholder?.Subject }
    const [isOpenPaymentModal, setisOpenPaymentModal] = React.useState(false);
    const [EcardCategoryList, setEcardCategoryList] = useState([]);
    const [AllEcardForInmateList, setAllEcardForInmateList] = useState([]);
    const [isloading, setisloading] = useState(false);
    const LoadQuarantineWords = useCheckQuarantineWords();
    const [customized, setCustomized] = useState(false);
    const [envelopecolor, setenvelopecolor] = useState("");
    const [ecardbgcolor, setecardbgcolor] = useState("");
    const [rippencolor, setrippencolor] = useState("");


    const handleSubmit = async () => {
        setErrorMessage({});
        const { error } = Send_ECardsSchema(formData);
        if (error) {
            error.details.forEach((e) => {
                setErrorMessage((prev) => ({
                    ...prev,
                    [e.path.toString()]: e.message,
                }));
            });
            return;
        }

        await LoadQuarantineWords(formData?.subject).then((x => {
            if (x?.isQuarantineWords && x?.highlightedWords) {
                setModalContent(`${currentLang?.Restricted_words} ${x?.highlightedWords}. ${currentLang?.Please_Remove}`);
                setmodalContentColor('#c8605e'); setShowPopup(true);
                return;
            }
            else {
                dispatch(E_CardActions.LoadSelectedEcardDetails({ EcardId: selectedCard.EcardId, FacilityId: storedLoginDetails?.FacilityID })).then((x) => {
                    if (x?.payload) {
                        const { VisibleTo, CostCategory, FacilityEcardCost } = x.payload;
                        if (VisibleTo !== 1) {
                            setSelectedCard(x.payload);
                            setFormData({
                                ...formData,
                                ecardCost: CostCategory !== 0 ? CostCategory : FacilityEcardCost
                            });
                            handleSend();
                            setisOpenPaymentModal(true);
                        }
                    } else {
                        handleUnavailableCard();
                    }
                });
            }
        }))
    }

    const handleMessageResponse = (data) => {
        const messages = {
            "1": {
                text: currentLang?.ECard_Popup?.ECard_sent_Success,
                color: "#4a9a93", resetForm: true,
            },
            "-1": {
                text: currentLang?.ECard_Popup?.Internal_Error,
                color: "#c8605e",
            },
            "-2": {
                text: currentLang?.ECard_Popup?.Credit_Balance_Low,
                color: "#c8605e",
            },
            "-3": {
                text: currentLang?.ECard_Popup?.Repeated_Subject_Conversation,
                color: "#c8605e",
                resetForm: true,
            },
            "-4": {
                text: currentLang?.ECard_Popup?.Inmate_Pu_Connection_InActive,
                color: "#c8605e",
            },
            "-5": {
                text: currentLang?.ECard_Popup?.Deactivated_PU,
                color: "#c8605e",
            },
            "-6": {
                text: currentLang?.ECard_Popup?.Permission_Restricted,
                color: "#c8605e",
            },
            "-7": {
                text: currentLang?.ECard_Popup?.Permission_Restricted,
                color: "#c8605e",
            },
            "-8": {
                text: currentLang?.ECard_Popup?.Error,
                color: "#c8605e",
            },
            "-9": {
                text: currentLang?.ECard_Popup?.CACTAS_credits_not_enabled,
                color: "#c8605e",
            },
            "-10": {
                text: currentLang?.ECard_Popup?.Credit_Balance_Low,
                color: "#c8605e",
            },
            "-11": {
                text: currentLang?.ECard_Popup?.Permission_Restricted,
                color: "#c8605e",
            },
            "-12": {
                text: currentLang?.ECard_Popup?.Connection_Blocked,
                color: "#c8605e",
            },
            "-13": {
                text: currentLang?.ECard_Popup?.Please_Choose_ECard,
                color: "#c8605e",
            },
        };

        const messageConfig = messages[data];
        if (messageConfig) {
            setModalContent(messageConfig.text);
            setmodalContentColor(messageConfig.color);
            setShowPopup(true);

            if (messageConfig.resetForm) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    user: '',
                    subject: '',
                    isUserdisabled: false
                }))
            }
        }
    };

    const SendECard = (paymentType, taskGUID, balanceValue) => {
        const PublicUserID = MyContactsDisplayForEcardDetails?.find(
            x => x?.PublicUserEmail === formData?.user
        )?.PublicUserID || 0;
        setisOpenPaymentModal(false);
        setisloading(true);
        const apiData = {
            publicUserID: PublicUserID,
            inmateID: storedloginResponse?.InmateID,
            facilityId: storedloginResponse?.facilityID,
            ecardName: selectedCard?.EcardName,
            ecardId: selectedCard?.EcardId,
            CategoryId: selectedCard?.CategoryId,
            ecardSubject: formData?.subject,
            ecardFilename: selectedCard?.EcardFileName,
            ecardFilepath: selectedCard?.EcardFilePath,
            isEmojiUsed: formData?.totalEmojiCost > 0 ? true : false,
            totalEcardCost: parseFloat(formData?.totalMessageCost).toFixed(2),
            paymentType: paymentType,
            cactasBalanceAmount: balanceValue,
            usedEcardEmojiCost: formData?.totalEmojiCost > 0 ? parseFloat(formData?.totalEmojiCost).toFixed(2) : 0,
            inmatesFullName: storedloginResponse?.InmateFullName,
            kioskMachineID: storedLoginDetails?.KiosksCode,
            podCode: storedLoginDetails?.PodCode,
            eCardCost: parseFloat(formData?.ecardCost).toFixed(2),
            inmateResidentId: storedloginResponse?.InmatesResdId,
            taskGUID: taskGUID,
            envelopecolor: envelopecolor,
            ecardbgcolor: ecardbgcolor,
            rippencolor: rippencolor
        };

        dispatch(E_CardActions.SaveInmateSendEcardDetails(apiData)).then((x) => {
            setisloading(false);
            setenvelopecolor(""); setecardbgcolor(""); setrippencolor(""); setCustomized(false);
            if (x?.payload?.message > 0 && x?.payload?.message != -100) {
                const notificationparams = { ...apiData, IsSucceed: x?.payload?.message }
                dispatch(E_CardActions.SendEcardNotificationEmail(notificationparams));
            }
            setModalContent(x?.payload?.message);
            handleMessageResponse(x?.payload?.message);
            if (paymentType == '2') {
                dispatch(inboxActions.LoadInmateFreeCreditBalanceResult({
                    inmateResidentID: storedloginResponse?.InmatesResdId,
                    facilityId: storedloginResponse?.facilityID,
                })).then((x) => {
                    if (x.payload?.length > 0) {
                        const { InmateFreeCreditAmount, FreeCreditActiveStatus } = x.payload[0];
                        setFormData(prevFormData => ({
                            ...prevFormData,
                            freeCredits: InmateFreeCreditAmount,
                            freeCreditStatus: FreeCreditActiveStatus === 1
                        }));
                    }
                })
            }
        });
    }

    const handleSend = () => {
        // dispatch(inboxActions.LoadCactasServiceDetailsResult({ facilityId: storedloginResponse?.facilityID }));
        const SelectUser = MyContactsDisplayForEcardDetails?.find(
            x => x?.PublicUserEmail === formData?.user);
        dispatch(inboxActions.LoadInmatePublicCreditBalanceResult({
            inmatesId: storedloginResponse?.InmateID,
            userId: SelectUser?.PublicUserID || 0,
            pUIConnectionID: SelectUser?.PUIConnectionID || 0,
        })).then((x) => {
            if (x?.payload?.length > 0) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    userCredits: x?.payload[0].CreditBalance
                }));
            }
        })
    };

    const handleselectCategory = (isAll, cat, EcardCategoryList) => {
        let updatedCategories = [];

        if (isAll) {
            // Toggle all: if "All" is already selected, deselect everything
            const allSelected = selectedCategories.includes(0);
            if (allSelected) {
                updatedCategories = [];
            } else {
                // Select "All" and all category IDs
                updatedCategories = [0, ...EcardCategoryList.map(c => c.CategoryId)];
            }
        } else {
            const isSelected = selectedCategories.includes(cat.CategoryId);
            if (isSelected) {
                // Deselect the category and also remove "All" if present
                updatedCategories = selectedCategories.filter(
                    id => id !== cat.CategoryId && id !== 0
                );
            } else {
                // Add the category, but remove "All"
                updatedCategories = [...selectedCategories.filter(id => id !== 0), cat.CategoryId];

                // Check if all individual categories are selected after this
                const allCategoryIds = EcardCategoryList.map(c => c.CategoryId).sort();
                const updatedSet = [...new Set(updatedCategories)].sort();
                const isAllNowSelected = JSON.stringify(updatedSet) === JSON.stringify(allCategoryIds);

                if (isAllNowSelected) {
                    updatedCategories = [0, ...allCategoryIds];
                }
            }
        }
        setSelectedCategories(updatedCategories);
        setFormData(prevFormData => ({
            ...prevFormData,
            pageNo: 1,
        }));
        setisloading(true);
        dispatch(E_CardActions.LoadAllEcardForInmate({
            CategoryId: updatedCategories?.includes(0) ? 0 : updatedCategories,
            PageNo: 1,
            RowCountPerPage: formData?.rowCountPerPage
        })).then((x) => {
            if (x?.payload) {
                setAllEcardForInmateList(x.payload?.DataList);
                setisloading(false);
            }
        });
    };

    const handleselectECard = (card) => {
        setSelectedCard(card);
        setisshowListPage(false); setRotation(0);
        setFormData({ ...formData, ecardCost: card.CostCategory, subject: "", user: "", isUserdisabled: false });
        dispatch(E_CardActions.LoadSelectedEcardDetails({ EcardId: card.EcardId, FacilityId: storedLoginDetails?.FacilityID })).then((x) => {
            if (x?.payload) {
                const { VisibleTo, CostCategory, FacilityEcardCost } = x.payload;
                if (VisibleTo !== 1) {
                    setSelectedCard(x.payload);
                    setFormData({
                        ...formData,
                        ecardCost: CostCategory !== 0 ? CostCategory : FacilityEcardCost
                    });
                } else {
                    handleUnavailableCard();
                }
            } else {
                handleUnavailableCard();
            }
        });
    }

    function handleUnavailableCard() {
        setSelectedCard(null);
        setisshowListPage(true);
        setModalContent(currentLang?.AlertPopup?.Ecard_currently_unavailable);
        setmodalContentColor('#c8605e');
        setShowPopup(true);
        dispatch(E_CardActions.LoadAllEcardForInmate({
            CategoryId: selectedCategories?.includes(0) ? 0 : selectedCategories,
            PageNo: 1,
            RowCountPerPage: formData?.rowCountPerPage
        })).then((x) => {
            if (x?.payload) {
                setAllEcardForInmateList(x.payload?.DataList);
            }
        });
    }

    useEffect(() => {
        setLoading(true);
        dispatch(E_CardActions.loadECardCategory()).then((x) => {
            if (x?.payload?.length > 0) {
                setEcardCategoryList(x?.payload);
                handleselectCategory(true, null, x?.payload);
            }
        });
        setLoading(false);
    }, []);

    const handleFieldClick = (field) => {
        setCurrentField(field); setIsKeyboardOpen(true); setvalues(formData);
    };

    const handleScroll = () => {
        if (AllEcardForInmateList?.length < AllEcardForInmateList[0]?.TotalCount) {
            const newPage = formData?.pageNo + 1;
            setFormData(prevFormData => ({ ...prevFormData, pageNo: newPage, }));
            dispatch(E_CardActions.LoadAllEcardForInmate({ CategoryId: selectedCategories?.includes(0) ? 0 : selectedCategories, PageNo: newPage, RowCountPerPage: formData?.rowCountPerPage })).then((x) => {
                if (x?.payload) {
                    setAllEcardForInmateList(prevMessages => [...prevMessages, ...x?.payload?.DataList]);
                }
            });
        }
    }

    useEffect(() => {
        handleScroll();
    }, [ECardloadMoreCount]);

    return (
        <>
            {isshowListPage ?
                <>
                    <div className="col-12 card-shop-container">
                        <div className="col-sm-4 col-md-4 col-lg-2 border-end Ecard-category-list">
                            <h4>{currentLang?.E_Cards?.Categories}</h4>
                            <CheckBoxInput
                                label={currentLang?.Select_All}
                                name={"CategoriesAll"}
                                id={'CategoriesAll'}
                                className='ECard-checkbox'
                                handleClick={() => { handleselectCategory(true, null, EcardCategoryList); }}
                                checked={selectedCategories?.includes(0)}
                            />
                            {EcardCategoryList?.map(cat => (
                                <CheckBoxInput
                                    label={cat?.label}
                                    name={"Categories"}
                                    className='ECard-checkbox'
                                    id={cat?.CategoryId}
                                    handleClick={() => { handleselectCategory(false, cat, EcardCategoryList); }}
                                    checked={selectedCategories?.includes(cat?.CategoryId)}
                                    disabled={formData?.isshowInvestigationinfo}
                                />
                            ))}
                        </div>
                        <div className="col-10 Ecard-grid">
                            {AllEcardForInmateList?.length > 0 ? AllEcardForInmateList?.map((card, index) => (
                                <div className="Ecard-item" key={index} onClick={() => {
                                    handleselectECard(card);
                                }}>
                                    <img src={`${process.env.REACT_APP_API_IMAGE_URL}${card?.EcardFilePath}`} alt={card.title} className='ecard-listimg' />
                                    <div className="card-title">{
                                        card?.EcardName?.trim()?.length > 30
                                            ? card.EcardName.trim().slice(0, 29) + '...'
                                            : card?.EcardName?.trim()?.length > 0 ? card?.EcardName :
                                                card?.EcardFileName?.trim()?.length > 30
                                                    ? card.EcardFileName.trim().slice(0, 29) + '...' : card?.EcardFileName}</div>
                                </div>
                            )) :
                                (!isloading && <span className="col-no-data">
                                    {selectedCategories?.includes(0) ? currentLang?.E_Cards?.NO_ECards :
                                        selectedCategories?.length == 0 ? currentLang?.E_Cards?.PLS_Select_Category :
                                            selectedCategories?.length > 0 ? currentLang?.E_Cards?.NO_ECards_this_Category :
                                                currentLang?.No_Data_Found}
                                </span>)
                            }
                        </div>
                    </div>
                    {AllEcardForInmateList?.length > 0 && (AllEcardForInmateList?.length < AllEcardForInmateList[0]?.TotalCount) &&
                        <div className="mt-1 div-load-more">
                            <button title={formData?.pageNo} onClick={() => { handleScroll() }} className="btn btn-outline-secondary btn-sm load-more-btn">
                                <i className="fa fa-plus"></i> {currentLang?.Messages?.Load_More}
                            </button></div>
                    }
                </>
                :
                <div className="p-2 ">
                    <div className="row gx-3 ">
                        <div className="col-lg-6 col-12">
                            {/* ENVELOPE */}

                            <CustomEcard
                                envelopecolor={envelopecolor} ecardbgcolor={ecardbgcolor} rippencolor={rippencolor}
                                setenvelopecolor={setenvelopecolor} setecardbgcolor={setecardbgcolor} setrippencolor={setrippencolor}
                                rotation={rotation} setRotation={setRotation} issendECard={true} customized={customized} setCustomized={setCustomized}
                                setLoading={setLoading} imgsrc={`${process.env.REACT_APP_API_IMAGE_URL}${selectedCard?.EcardFilePath}`} isimgrotation={false} />

                            {/* <CustomPhoto rotation={rotation} setRotation={setRotation}
                                setLoading={setLoading} imgsrc={`${process.env.REACT_APP_API_IMAGE_URL}${selectedCard?.EcardFilePath}`} isimgrotation={false} /> */}
                        </div>
                        <div className="write-message-form col-lg-6 col-12">

                            <div className="ecard-title">
                                <h3>{selectedCard.title}</h3>
                            </div>
                            {formData?.freeCreditStatus && <div className="message-cost">
                                <label className="msg-cost">
                                    {currentLang?.Messages?.AVAILABLE_FREE_CREDITS}
                                    <span className="cost-value ml-5">
                                        $<span id="spnMessageCost">{formData?.freeCredits || 0}</span>
                                    </span>
                                </label>
                            </div>}
                            <div className="message-cost">
                                <label className="msg-cost">
                                    {currentLang?.E_Cards?.E_Card_Cost}  {" :"}
                                    <span className="noWrap class-balance ml-5 cost-value">
                                        $<span id="spnMessageCost">{parseFloat(formData.ecardCost).toFixed(2)}</span>
                                    </span>
                                </label>
                                {(CactasServiceDetailsResult?.length > 0 && CactasServiceDetailsResult[0]?.IsEmojiEnabled) && <> <label className="msg-cost">
                                    {currentLang?.Messages?.Emoji_Cost}
                                    <span className="cost-value ml-5">
                                        $<span id="spnEmojiCost">{parseFloat(formData?.facilityEmojiCost || 0).toFixed(2)}</span>
                                    </span>
                                </label>
                                    <label className="ms-2 mt-1">
                                        <i onClick={() => {
                                            setShowPopup(true); setModalContent(currentLang?.AlertPopup?.Same_Emoji_Content)
                                            setmodalContentColor('#1d1d1d')
                                        }} className="fa fa-info-circle info-emoji"></i>
                                    </label></>
                                }
                            </div>
                            <SelectInput
                                options={MyContactsDisplayForEcardDetails?.filter(x => x?.ConnectionStatusID != 3 && x?.ConnectionStatusID != 4)?.sort((a, b) => a.PublicUserName.localeCompare(b.PublicUserName))}
                                labelKey='PublicUserName'
                                valueKey='PublicUserEmail'
                                label=""
                                name="user"
                                isDisabled={formData?.isUserdisabled}
                                value={formData.user}
                                isClearable={false}
                                placeholder={currentLang?.Messages?.User_Placeholder}
                                errorMessage={errorMessage}
                                handleChange={e => {
                                    setFormData({ ...formData, ["user"]: e.value });
                                    setErrorMessage((prev) => ({
                                        ...prev,
                                        user: e.value ? "" : currentLang?.ValidationSchema?.Please_select_user,
                                    }));
                                }}
                            />
                            <CustomInput
                                type="text"
                                placeholder={currentLang?.Messages?.Subject_Placeholder}
                                value={formData.subject}
                                onClick={() => handleFieldClick('subject')}
                                errorMessage={errorMessage?.subject}
                            />
                            {IsKeyboardOpen && (
                                <CustomKeyboard
                                    currentField={currentField}
                                    setCurrentField={setCurrentField}
                                    inputs={formData}
                                    setShowBoard={setIsKeyboardOpen}
                                    setInputs={setFormData}
                                    fields={allFields}
                                    setErrorMessage={setErrorMessage}
                                    type="Multiple"
                                    handleCancel={() => { setFormData(values); setIsKeyboardOpen(false) }}
                                    setValues={setvalues}
                                    placeholderList={placeholder}
                                    isECardEmojiEnabled={CactasServiceDetailsResult[0]?.IsEmojiEnabled}
                                />
                            )}
                            <div className="d-flex justify-content-start  mt-30">
                                <Button label={"CUSTOMIZE"} disabled={customized}
                                    className='btn-danger me-2' status="back" type="submit" onClick={() => {
                                        setCustomized(true);
                                        setenvelopecolor("#6c6ca8");
                                        setecardbgcolor("#d8d8fb");
                                        setrippencolor("#ff3b3b");
                                    }} />
                                <Button label={currentLang?.Buttons?.Send} className='me-2' status="success" type="submit" onClick={() => { handleSubmit() }} />
                                <Button label={currentLang?.Buttons?.Reset} className="btn btn-warning" type="button" onClick={() => {
                                    setCustomized(false);
                                    setenvelopecolor("");
                                    setecardbgcolor("");
                                    setrippencolor("");
                                    setFormData(prevData => ({
                                        ...prevData,
                                        subject: "", user: "", isUserdisabled: false,
                                    })); setErrorMessage({})
                                }} />
                            </div>
                            <p className="textnote">{currentLang?.Messages?.Textnote}</p>
                        </div>
                    </div>
                </div>
            }
            {showPopup && (
                <CustomModal
                    color={modalContentColor}
                    content={modalContent}
                    onOkClick={() => setShowPopup(false)}
                />
            )}
            {isloading && <Loader isConvo={!isshowListPage ? true : false} />}
            {isOpenPaymentModal &&
                <PaymentModal CactasServiceDetailsResult={CactasServiceDetailsResult[0]} setFormData={setFormData} SendMessage={SendECard} formData={formData}
                    show={isOpenPaymentModal} onClose={() => { setisOpenPaymentModal(false) }} />}
        </>
    );
};

export default memo(Send_E_Card);